export const CHANGE_EMAIL = 'CHANGE_EMAIL'
export default function signalRMiddleware (signalrHub) {

  const hub = signalrHub

  // the middleware
  return (store) => {
    return (next) => (action) => {
      if (action.signalR) {
        switch (action.type) {
          case CHANGE_EMAIL:
            // const myCurrentState = store.getState().objectWithinState;
            hub.server.changeEmail()
            break
        }
      }
      return next(action)
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/signalR/signalRMiddleware.js